<template>
  <div>
    <div class="table" v-if="list.brandLevels && list.brandLevels.length > 0" :style="{
            'border':list.brandLevels && list.brandLevels.length > 0 ? '1px solid #bdc3c7':'none'
        }">
      <div class="input-code">
        <span>供应商编码：</span>
        <el-input disabled size="mini" v-model="list.vendorCode" class="input"/>
        <el-button v-if="list.vendorCode != freezeList.vendorCode && roles" class="button" type="primary"
                   @click="saveCode">保存
        </el-button>
      </div>
      <div class="title" :style="{'padding-right':getWidth()+'px'}">
        <div class="title-name" :style="{'width':`calc(100% / ${titleList.length})`}" v-for="(item,index) in titleList">
          {{ item }}
        </div>
      </div>
      <div class="cell-scroll">
        <div class="cell" v-for="(item,index) in list.brandLevels">
                    <span v-if="!isZiCai" class="cell-value" :style="{'width':`calc(100% / ${titleList.length})`}">
                        <el-dropdown @command="brandChange($event,item)">
                            <span class="el-dropdown-link">
                                {{ item.brandName }}<i v-if="roles" class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu v-if="roles" class="brand-menu" slot="dropdown">
                                <el-dropdown-item :disabled="!roles" :command="items" v-for="items in brands">
                                    {{ items.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </span>
          <!--                    <span class="cell-value" :style="{'width':`calc(100% / ${titleList.length})`}">-->
          <!--                        <el-dropdown @command="vendelLevelChange($event,item)">-->
          <!--                            <span class="el-dropdown-link">-->
          <!--                                {{ item.level}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
          <!--                            </span>-->
          <!--                            <el-dropdown-menu  slot="dropdown">-->
          <!--                                <el-dropdown-item :disabled="!roles" v-for="items in levelList" :command="items.name">-->
          <!--                                    {{items.name}}-->
          <!--                                </el-dropdown-item>-->
          <!--                            </el-dropdown-menu>-->
          <!--                        </el-dropdown>-->
          <!--                    </span>
          <span class="cell-value regions-cell" :style="{'width':`calc(100% / ${titleList.length})`}">
                        <el-select @change="regionsChange($event,item)" size="mini" :collapse-tags="true"
                                   v-model="item.brandRegionNames" multiple placeholder="请选择">
                            <el-option v-for="item in regions" :key="item.code" :label="item.name" :value="item.name">
                            </el-option>
                        </el-select>
                    </span>-->
          <span class="cell-value" style="display: flex;justify-content: flex-start;padding: 0 20px"
                :style="{'width':`calc(100% / ${titleList.length})`}">
                        <div class="saveButton">
                            <el-popconfirm v-if="roles && !isZiCai" confirm-button-type="danger"
                                           @onConfirm="deleteCell(item,index)"
                                           title="确认删除？">
                                <el-button slot="reference" size="small" type="danger">删除</el-button>
                            </el-popconfirm>
                            <el-button class="button2" v-if="filterCellButton(index)" size="small" type="primary"
                                       @click="saveCell(item)">
                                {{ item.id ? '修改' : '保存' }}</el-button>
                        </div>
                    </span>
        </div>
      </div>

    </div>
    <el-button size="small" type="primary" @click="add" v-if="filterAddButton() && roles && filterZiCar()">添加
    </el-button>
  </div>
</template>
<script>
import {
  addVendorBrandLevel,
  delVendorBrandLevel,
  showBrandsBySearchName,
  showRegionsBySearchName,
  showVendorBrandLevels,
  updVendorBrandLevel,
  updVendorCodeByxq,
  vendorCodeIsOrNo
} from "@/api/api"

export default {
  props: {
    roles: {
      type: Boolean,
      default: false
    },
    id: {
      type: String | Number
    },
    code: {
      type: String | Number
    },
    isZiCai: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      levelList: [{name: "优选供应商"}, {name: "合格供应商"}, {name: "新入供应商"}],
      list: {
        brandLevels: [],
        id: "",
        name: "",
        vendorCode: ""
      },
      brands: [],
      titleList: ["认证品牌"],
      regions: [],
      freezeList: [],
      isStatus: false
    }
  },
  watch: {
    isZiCai: {
      async handler(newValue, oldValue) {
        //如果是从自采变为了集采
        //把添加的数据删除 重新设置
        if (newValue && (!oldValue && typeof oldValue === "boolean") && this.list.brandLevels.length > 0) {
          const loading = this.$loading({
            lock: false,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          for (let i = 0; i < this.list.brandLevels.length; i++) {
            const item = this.list.brandLevels[i];
            if (item.id) {
              const result = await delVendorBrandLevel({
                id: item.id
              });
            } else {
              this.list.brandLevels.splice(i, 1);
            }
          }
          loading.close();
          await this.getShowVendorBrandLevels();
        }
        if (newValue) {
          this.titleList.shift();
        } else {
          if (this.titleList.includes("认证品牌")) return;
          this.titleList.unshift("认证品牌");
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.getShowVendorBrandLevels(true);
    // if(this.roles){
    this.titleList.push("操作");
    // }
  },
  methods: {
    filterZiCar() {
      if (this.isZiCai && this.list.brandLevels.length > 0) {
        return false;
      }
      return true;
    },
    getWidth() {
      var cWidth = document.body.clientWidth || document.documentElement.clientWidth;
      var iWidth = window.innerWidth;
      return iWidth - cWidth;
    },
    async saveCode() {
      const state = await this.getVendorCodeIsOrNo();
      if (!state) {
        this.$message.warning("供应商编码重复");
        return;
      }
      const result = await updVendorCodeByxq({
        id: this.id,
        vendorCode: this.list.vendorCode
      });
      if (result.status === 200 && result.data && result.data.code === 0) {
        this.$message.success("保存成功");
        this.getShowVendorBrandLevels(false, true);
      } else {
        this.$message.warning("保存失败");
      }
    },
    filterAddButton() {
      const old = JSON.stringify(this.freezeList.brandLevels);
      const newV = JSON.stringify(this.list.brandLevels);
      return newV === old
    },
    async deleteCell(item, index) {
      console.log(123123);
      if (item.id) {
        const loading = this.$loading({
          lock: false,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const result = await delVendorBrandLevel({
          id: item.id
        });
        if (result.status === 200 && result.data && result.data.code === 0) {
          this.$message.success("删除成功");
          this.getShowVendorBrandLevels();
        } else {
          this.$message.warning("删除失败");
        }
        setTimeout(() => {
          loading.close();
        }, 500);
      } else {
        this.list.brandLevels.splice(index, 1);
      }
    },
    async getVendorCodeIsOrNo() {
      return new Promise(async (resolve, reject) => {
        const result = await vendorCodeIsOrNo({vendorCode: this.list.vendorCode});
        if (result.status === 200 && result.data && result.data.code === 0) {
          this.isStatus = result.data.data;
        }
        resolve(this.isStatus);
      })

    },
    saveCell(item) {
      if (!this.list.vendorCode) {
        return this.$message.warning("缺少供应商编码");
      }
      if (!item.brandCode && !this.isZiCai) {
        return this.$message.warning("请选择品牌")
      }
      console.log("请选择服务区域",item);
      const config = {
        brandCode: this.isZiCai ? 'la0101' : item.brandCode,
        brandName: this.isZiCai ? '锦江之星' : item.brandName,
        brandRegionNames: '全部',
        level: item.level,
        vendorCode: this.freezeList.vendorCode,
        id: item.id ? item.id : this.list.id
      }
      item.id ? this.doEditSaveCell(config) : this.doSaveCell(config);
    },
    // 修改
    async doEditSaveCell(config = {}) {
      const loading = this.$loading({
        lock: false,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const result = await updVendorBrandLevel(config);
      if (result.status === 200 && result.data && result.data.code === 0 && result.data.data === 1) {
        this.$message.success("保存成功");
        this.getShowVendorBrandLevels();
      } else {
        this.$message.warning("保存失败");
      }
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    // 保存数据
    async doSaveCell(config = {}) {
      const loading = this.$loading({
        lock: false,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const result = await addVendorBrandLevel(config);
      if (result.status === 200 && result.data && result.data.code === 0 && result.data.data === 1) {
        this.$message.success("保存成功");
        await this.getShowVendorBrandLevels();
      } else {
        this.$message.warning("保存失败");
      }
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    regionsChange(event, item) {
      const result = event.find(ele => ele === '全部');
      if (result) {
        item.brandRegionNames.length = 0;
        item.brandRegionNames.push('全部');
      }
    },
    filterCellButton(index) {
      const old = JSON.stringify(this.freezeList.brandLevels[index]);
      const newV = JSON.stringify(this.list.brandLevels[index]);
      return newV !== old
    },
    brandChange(event, item) {
      item.brandCode = event.code;
      item.brandName = event.name;
    },
    vendelLevelChange(event, item) {
      item.level = event;
    },
    add() {
      if (this.brands.length <= 0) {
        this.$message.warning("暂无可供选择的品牌");
        return;
      }
      this.list.brandLevels.push({
        brandName: "请选择",
        brandCode: null,
        brandRegionNames: "请选择",
        level: "请选择"
      })
    },
    // 区域
    async getShowRegionsBySearchName() {
      const result = await showRegionsBySearchName();
      if (result.status === 200 && result.data.code === 0 && result.data && result.data.data.length > 0) {
        this.regions = result.data.data;
      } else {
        this.$message.warning('品牌信息获取失败');
      }
    },

    // 获取品牌、等级、区域列表
    async getShowVendorBrandLevels(first = false, vendorCodeChange = false) {
      const loading = this.$loading({
        lock: false,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const result = await showVendorBrandLevels({
        id: this.id
      });
      if (result.status === 200 && result.data.code === 0 && result.data && result.data.data.id.length > 0) {
        if (vendorCodeChange) {
          this.list.vendorCode = result.data.data.vendorCode;
          this.freezeList.vendorCode = result.data.data.vendorCode;
        } else {
          result.data.data.brandLevels.forEach(ele => {
            ele.brandRegionNames = ele.brandRegionNames.split(',');
          })
          this.list = result.data.data;
          this.freezeList = JSON.parse(JSON.stringify(result.data.data));
        }

      }
      if (first) {
        await this.getShowRegionsBySearchName();
      }
      await this.getBrands();
      setTimeout(() => {
        loading.close();
      }, 500);
    },
    // 品牌
    async getBrands() {
      const result = await showBrandsBySearchName({vendorCode: this.code});
      if (result.status === 200 && result.data.code === 0 && result.data && result.data.data.length >= 0) {
        this.brands = result.data.data;
      } else {
        this.$message.warning('品牌信息获取失败');
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.input-code {
  display: flex;
  height: 40px;
  border-bottom: 1px solid #bdc3c7;
  padding: 0 10px;
  box-sizing: border-box;

  .button {
    width: 50px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    margin-left: 10px;
    font-size: 12px;
  }

  span {
    display: block;
    width: 90px;
  }

  .input {
    width: 200px;
    height: 20px;
  }
}

.brand-menu {
  overflow-y: scroll;
  height: 300px;
}

/deep/ .el-dropdown-link {
  white-space: nowrap !important;
}

.table {
  .cell-scroll {
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;
  }

  .title {
    display: flex;
    box-sizing: border-box;

    .title-name {
      width: calc(100% / 4);
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #bdc3c7;
      border-bottom: 1px solid #bdc3c7;
    }

    .title-name:last-child {
      border-right: none;
    }
  }

  width: 800px;
  border-radius: 5px;
  box-sizing: border-box;

  .cell {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    border-bottom: 1px solid #bdc3c7;
    height: 40px;
    position: relative;

    .saveButton {
      width: 130px;

      .button2 {
        margin-left: 10px;
      }
    }

    .cell-value {
      width: calc(100% / 4);
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      border-right: 1px solid #bdc3c7;
    }

    .cell-value:last-child {
      border-right: none;
    }
  }

  .cell:last-child {
    border-bottom: none;
  }
}
</style>
